import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileReaderService } from '../../services/file-reader/file-reader.service';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
})
export class FileInputComponent implements OnInit {
  @Input()
  name = '';

  @Output()
  readonly fileReady: EventEmitter<File> = new EventEmitter<File>();

  private file?: File;

  constructor() {}

  ngOnInit(): void {}

  fileChanged(event: Event): void {
    this.file = (event.target as any).files[0];
    this.fileReady.emit(this.file);
  }
}
